import { Circle, Page } from '@/components';
import { useSearchParams } from '@/hooks';
import { collateralColorPalette } from '@/theme/utils/collateralColorPalette';
import { Flex, Heading } from '@blockanalitica/ui';
import { useTheme } from 'styled-components';
import IlksTable from './IlksTable';
import OverviewKpis from './OverviewKpis';

export default function StablecoinsPage() {
  const [daysAgo] = useSearchParams('days_ago', '1');
  const theme = useTheme();
  return (
    <Page
      title={
        <Flex gap="3xs" alignItems="center">
          <Circle
            size="3"
            color={collateralColorPalette(
              'stablecoins',
              theme.colors.collateralColors
            )}
          />
          <Heading size="1"> Stablecoins</Heading>
        </Flex>
      }>
      <OverviewKpis daysAgo={daysAgo} />
      <IlksTable daysAgo={daysAgo} />
    </Page>
  );
}
